import { render, staticRenderFns } from "./HotlineInfoModal.vue?vue&type=template&id=135b9c2a&scoped=true&"
import script from "./HotlineInfoModal.vue?vue&type=script&lang=js&"
export * from "./HotlineInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./HotlineInfoModal.vue?vue&type=style&index=0&id=135b9c2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b9c2a",
  null
  
)

export default component.exports